import type { NopSectionDto } from '@/api/types/consolidatedExposure';

// NOP Stress Test. Service /api/app/nop-stress-test (ABP strips Get).
export const StressTestType = { None: 0, ParallelShift: 1, SensitivityAnalysis: 2, ScenarioAnalysis: 3 } as const;
export const StressTestTarget = { Price: 0, Volume: 1 } as const;

export interface StressTestFiltersDto {
  uniqueId?: string | null;
  login?: number | null;
  platformId?: number | null;
  instrument?: string | null;
  portfolioId?: number | null;
  ccyCurrency: boolean;
  byUniqueId: boolean;
  autoMap: boolean;
}

export interface StressTestModifiedPriceDto { instrument: string; price: number }
export interface StressTestModifiedVolumeDto { instrument: string; volume: number }

export interface StressTestConfigurationDto {
  type: number;
  parallelShift?: number | null;
  instrument?: string | null;
  modifiedPrices?: StressTestModifiedPriceDto[] | null;
  modifiedVolumes?: StressTestModifiedVolumeDto[] | null;
  target: number;
}

export interface StressTestInputDto {
  filters: StressTestFiltersDto;
  configuration: StressTestConfigurationDto;
}

export interface LoginStopOutResultDto {
  login: number;
  platformId: number;
  platform: string;
  usableFunds: number;
  stressedEquity: number;
  pnl: number;
  originalPnl: number;
  pnlDifference: number;
  negativeBalance: number;
  creditDeficit: number;
  status: string;
}
export interface StressTestStopOutResultDto {
  nonCcyClients: LoginStopOutResultDto[];
  nonCcyFirm: LoginStopOutResultDto[];
  nonCcyLp: LoginStopOutResultDto[];
  nonCcyReciptionAndTransmission: LoginStopOutResultDto[];
}

export interface StressTestResultDto {
  clientsNop: NopSectionDto;
  firmNop: NopSectionDto;
  lpNop: NopSectionDto;
  rtNop: NopSectionDto;
  clientsNopCcy: NopSectionDto;
  firmNopCcy: NopSectionDto;
  lpNopCcy: NopSectionDto;
  rtNopCcy: NopSectionDto;
  missingSymbolsNotification: string;
  missingGroupsNotification: string;
  errorMessage: string;
  stopOutResult: StressTestStopOutResultDto;
  createdAt: string;
}

export interface ReverseStopOutInputDto { login: number; instrument: string; connectorId?: number | null }
export interface ReverseStopOutPositionDto {
  login: number; symbol: string; volume: number; openPrice: number; type: string; digits: number;
  currentPrice: number; originalFloating: number; recalculatedFloating: number; floatingDifference: number;
}
export interface ReverseStopOutResultDto {
  resultPrice: number; originalPrice: number; priceDifference: number; priceVariationPercent: number;
  quoteCurrency: string; accountCurrency: string; equityInAccountCurrency: number; equityInQuoteCurrency: number;
  netVolume: number; netExposure: number; contractSize: number; digits: number; positions: ReverseStopOutPositionDto[];
}

export interface PricesAndVolumesDto { symbol: string; bid: number; volume: number }
export interface QuickStressTestConfigurationDto { id: number; name: string; percentage: number; isActive: boolean; displayOrder: number }
